module.exports = __webpack_public_path__ + "img/logo.6a32b989.png";